<template>
  <div class="inventory-items">
    <div>
      <div class="title">
        Товарно-материальные ценности
        <Button
          responsive
          label="Выдать ТМЦ"
          :icon="{
            icon: 'plus',
            color: 'blue',
          }"
          @click="issueItem"
        />
      </div>
      <ItemsTable
        ref="itemsTable"
        :worker-id="workerId"
        @change="update"
      />
    </div>
    <div>
      <div class="title">История изменений</div>
      <HistoryTable
        ref="historyTable"
        :worker-id="workerId"
      />
    </div>
    <IssueItemModal
      ref="issueInventoryItemModal"
      :worker-id="workerId"
      @submit="update"
    />
    <TopButton root=".layout" />
  </div>
</template>

<script>
import Button from "@/components/controls/button.vue";
import TopButton from "@/components/top-button.vue";
import ItemsTable from "./components/items-table/VComponent.vue";
import HistoryTable from "./components/history-table/VComponent.vue";
import IssueItemModal from "./components/IssueItemModal.vue";

export default {
  name: "personal-employee-inventory-items",
  components: {
    Button,
    TopButton,
    ItemsTable,
    HistoryTable,
    IssueItemModal,
  },
  computed: {
    workerId () {
      return this.$route.params.id;
    },
  },
  methods: {
    issueItem() {
      this.$refs.issueInventoryItemModal.open();
    },
    update() {
      this.$refs.itemsTable.fetchData();
      this.$refs.historyTable.fetchData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/vars';

.inventory-items {
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  gap: 65px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;

  @include onlyMobile {
    font-size: 15px;
  }
}
</style>

<style>
.m-comment__text{
  overflow: hidden!important;
  text-overflow: ellipsis!important;
}
</style>
